import { useMutation, useQueryClient } from "@tanstack/react-query";
import { runHarvestNow } from "../api/harvestApi";
import { queryKeys } from "../lib/queryKeys";

export function useRunHarvest() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (dryRun: boolean) => runHarvestNow(dryRun),
    onSuccess: (data) => {
      if (!data.dryRun) {
        qc.invalidateQueries({ queryKey: queryKeys.parcours.all });
        qc.invalidateQueries({ queryKey: queryKeys.lieux.all });
      }
      qc.invalidateQueries({ queryKey: ["harvest", "config"] });
    },
  });
}
